// extracted by mini-css-extract-plugin
module.exports = {"upperBar":"UpperBar_upperBar__3I605","ncBtn":"UpperBar_ncBtn__1oCIr","ncIcon":"UpperBar_ncIcon__2pZTx","avatar":"UpperBar_avatar__1Qq-R","toolsBar":"UpperBar_toolsBar__1mWq7"};